
(function metadataControllerDefinition() {
    'use strict';

    angular.module('Metadata')
        .controller('MetadataModifyController', [
            '$scope', '$state', 'errorsExtend', '$stateParams', 'metadataService', 'configViewService',
            function metadataController($scope, $state, errors, $stateParams, metadataService, configViewService) {
                $scope.option = {
                    id: 0,
                    description: '',
                    value: '',
                    enabled: true
                }

                metadataService.getById($stateParams.id).then(function (result) {
                    $scope.metadata = {
                        id: result.id,
                        systemName: result.systemName,
                        label: result.name,
                        dataType: result.type,
                        organizationalUnitId: result.organizationUnitId,
                        organizationalUnitName: result.organizationUnitName,
                        optionValues: result.optionValues
                    };

                }, function (error) {
                    errors.showError(error);
                    $state.go('metadata-find');
                });

                $scope.save = function () {
                    if (!$scope.metadataForm.$valid) {
                        errors.showError('VerifyFormData');
                        $scope.metadataForm.$setSubmitted();
                        return false;
                    }

                    return metadataService.modify($scope.metadata).then(function (metadata) {
                        configViewService.clear();
                        $state.go('metadata-find');
                    }, function (error) {
                        errors.showError(error);
                        $state.go('metadata-find');
                    });
                };

                $scope.cancel = function () {
                    $state.go('metadata-find');
                };

                $scope.existOption = function () {
                    if ($scope.metadata.optionValues && $scope.metadata.optionValues.length > 0) {
                        for (var i = 0; i < $scope.metadata.optionValues.length; i++) {
                            if ($scope.metadata.optionValues[i].value === $scope.option.value ||
                                $scope.metadata.optionValues[i].description === $scope.option.description) {
                                return true;
                            }
                        }
                    }

                    return false;
                }

                $scope.addOption = function () {
                    if ($scope.option.description) {
                        var maxId = Math.max.apply(Math, $scope.metadata.optionValues.map(function (item) { return item.id; }));
                        $scope.option.id = isFinite(maxId) ? maxId + 1 : 1;

                        var words = $scope.option.description.split(' ');

                        if (words.length > 1) {
                            for (var i = 0; i < words.length; i++) {
                                if (isNaN(words[i][0])) {
                                    $scope.option.value += words[i][0];
                                }
                            }
                        } else {
                            if (words[0].length >= 3) {
                                $scope.option.value = words[0].substring(0, 3);
                            } else {
                                $scope.option.value = words[0];
                            }
                        }

                        $scope.option.value += $scope.option.id;

                        if (!$scope.existOption()) {
                            $scope.metadata.optionValues.push($scope.option);
                            $scope.option = {
                                id: 0,
                                description: '',
                                value: '',
                                enabled: true
                            }
                        }
                    }
                };

                $scope.removeOption = function (item) {
                    var indexOf = -1;
                    for (var i = 0; i < $scope.metadata.optionValues.length; i++) {
                        if ($scope.metadata.optionValues[i] === item) {
                            indexOf = i;
                            break;
                        }
                    }

                    if (indexOf >= 0) {
                        $scope.metadata.optionValues.splice(indexOf, 1);
                    }
                };
            }
        ]);
})();